import { DataGrid, DateBox, DropDownBox, ScrollView } from "devextreme-react";
import { Column, FilterRow, Selection } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useState } from "react";
import { ColumnDropdown } from "../../../../../components/Dropdownn";
import { handleGetLocal } from "../../../../../services/auth-service";
import axios from "axios";
import './AddJailServiceLogPopup.css'
import { getDateBoxFormat } from "../../../../Dateapi/dateFormatter";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
      />
    </>
  );
};

export const AddJailServiceLogPopup = ({
  addJailServiceLogPopup,
  setAddJailServiceLogPopup,
  jailCompletedType,
  userinfo,
  dropdownData,
  docketDropdownData,
  jailRowData,
  toastConfig,
  setToastConfig,
  setLoading,
  getJailCopletedServiceListApi,
  setJailTimeTab,
  JailtimelogDropdown,
  gotodocker,
  dockertDetail,
  jailPlannedData,
  getJailPlannedServiceListApi,
}) => {
  const [serviceType, setServiceType] = useState("daysServed");
  const [selectedValue, setSelectedValue] = useState({
    Court: "",
    Docket: "",
    "Sentence Date": "",
    "Supervision Status": "",
    gDocketId: "",
  });
  const [dataSource, setDataSource] = useState([]);
  const [fields, setFields] = useState({
    reason: { name: "", id: "" },
    workSite: { name: "", id: "" },
    daysCompleted: "1",
    date: "",
    hoursWrittenOff: "",
  });
  const [docketvalidation, setDocketvalidation] = useState("");
  const [workSitevalidation, setWorkSitevalidation] = useState("");
  const [reasonvalidation, setReasonvalidation] = useState("");
  const [dateValidation, setDateValidation] = useState("");
  const [hoursWrittenOffValidation, setHoursWrittenOffValidation] = useState("");
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  console.log("jailPlannedData", jailPlannedData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "hoursWrittenOff") {
      if (fields?.hoursWrittenOff?.trim() === "" || value[0] === " ") {
        setHoursWrittenOffValidation("Please enter valid Hours Written Off");
      } else {
        setHoursWrittenOffValidation("");
      }
    }
  };

  const handleServiceTypeChange = (event) => {
    setServiceType(event.target.value);
    if (event.target.value === "daysServed") {
      setFields((prevFields) => ({
        ...prevFields,
        hoursWrittenOff: "",
      }));
    }
  };

  const fetchedDataSource = docketDropdownData?.map((val) => {
    const convertDateFormat = (dateString) => {
      const dateObj = new Date(dateString);
      return dateObj.toLocaleDateString("en-US");
    };
    return {
      Court: val?.sCourtName,
      Docket: val?.sDocketNumberCourtCounts,
      "Sentence Date": convertDateFormat(val?.dSentence),
      "Supervision Status": val?.sSupervisionStatusName,
      gDocketId: val?.gDocketId,
    };
  });
  useEffect(() => {
    if (jailCompletedType === "ADD") {
      setFields({
        reason: { name: "", id: "" },
        workSite: { name: "", id: "" },
        daysCompleted: "1",
        date: "",
        hoursWrittenOff: "",
      });
      const selectedDocket = dataSource?.find((item) => item.gDocketId === dockertDetail?.id);
      setSelectedValue(selectedDocket);
      setDocketvalidation("");
      setWorkSitevalidation("");
      setReasonvalidation("");
      setDateValidation("");
      setHoursWrittenOffValidation("");
      setDataSource(fetchedDataSource);
      setServiceType("daysServed");
    } else {
      let checkedType =
        jailRowData?.[`Write Off Reason`]?.length === undefined || jailRowData?.[`Write Off Reason`] === ""
          ? "daysServed"
          : "hoursWrittenOff";
      setServiceType(checkedType);
      const findKeyById = (id, data) => {
        const item = data?.find((item) => item?.key.toLowerCase() === id?.toLowerCase());
        return item ? item.value : "";
      };
      const reasonName = findKeyById(jailRowData?.gJailTimeReasonId, dropdownData?.jailReasons);
      const workSiteName = findKeyById(jailRowData?.workSiteId, JailtimelogDropdown);
      setFields((prevFields) => ({
        ...prevFields,
        reason: {
          ...prevFields.reason,
          name: reasonName,
          id: jailRowData?.gJailTimeReasonId,
        },
        workSite: {
          ...prevFields.workSite,
          name: workSiteName,
          id: jailRowData?.workSiteId,
        },
      }));
      const selectedDocket = dataSource?.find((item) => item.gDocketId === jailRowData?.docketId);
      setSelectedValue(selectedDocket);
      setDataSource(fetchedDataSource);
      setFields((prev) => ({
        ...prev,
        daysCompleted: jailRowData?.[`Days Completed`],
        date: jailRowData?.[`Date Completed`],
        hoursWrittenOff: jailRowData?.[`Write Off Reason`],
      }));
    }
  }, [jailRowData, addJailServiceLogPopup]);

  const data = {
    jailTimeLogId: jailCompletedType === "ADD" ? "" : jailRowData?.jailTimeLogId,
    docketId: selectedValue?.gDocketId,
    date: fields.date,
    workSiteId: fields?.workSite?.id,
    reasonId: fields?.reason?.id,
    daysCompleted: fields?.daysCompleted,
    sWriteOffReason: fields?.hoursWrittenOff,
  };

  const handleSave = async () => {
    let isValid = true;
    if (!selectedValue?.gDocketId) {
      setDocketvalidation("Please Select Docket");
      isValid = false;
    }
    if (!fields.date) {
      setDateValidation("Please Select Date");
      isValid = false;
    }
    if (!fields.reason.id) {
      setReasonvalidation("Please Select Reason");
      isValid = false;
    }
    if (!fields.workSite.id || !fields.workSite.name) {
      setWorkSitevalidation("Please Select Work Site");
      isValid = false;
    }
    if (serviceType === "hoursWrittenOff" && !fields.hoursWrittenOff) {
      setHoursWrittenOffValidation("Please Enter Hours Written Off");
      isValid = false;
    }
    if (isValid) {
      setLoading(true);
      const pathname = handleGetLocal("pathURL");
      await axios
        .post(`${process.env.REACT_APP_API_URL}/api/jail-time/save-jailtime-log`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        })
        .then((val) => {
          setLoading(false);
          setAddJailServiceLogPopup(false);
          getJailCopletedServiceListApi();
          getJailPlannedServiceListApi();
          setJailTimeTab(2);
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            message: jailCompletedType === "ADD" ? "Successfully Added!" : "Successfully Updated!",
            type: "success",
          });
          setTimeout(() => {
            setToastConfig({
              ...toastConfig,
              isVisible: false,
              message: jailCompletedType === "ADD" ? "Successfully Added!" : "Successfully Updated!",
              type: "success",
            });
          }, 1900);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        });
    }
  };
  const onGridBoxOpened = useCallback((e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  }, []);

  return (
    <div className="add_jail_services_log">
      <div className="popup_header">
        <div className="popup_header_title">
          <div class="popup_header_title_data">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="add" clipPath="url(#clip0_5349_5505)">
                <path
                  id="Vector"
                  d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
                  fill="#fff"
                />
              </g>
              <defs>
                <clipPath id="clip0_5349_5505">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>Jail Time log</p>
          </div>
          <p class="popup_header_title_para">JT.2</p>
        </div>
        <svg
          onClick={() => {
            setAddJailServiceLogPopup(false);
          }}
          style={{
            cursor: "pointer",
          }}
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
            fill="white"
          />
        </svg>
      </div>
      <ScrollView>
        <div className="add_community_service_content" style={{ gap: "30px" }}>
          <div className="edit_container_first">
            <div className="edit_content_flex">
              <p className="edit_container_label">
                Docket <span className="marks_mandatary">*</span>
              </p>
              <DropDownBox
                placeholder="Select..."
                dataSource={dataSource}
                disabled={gotodocker ? true : false}
                value={selectedValue?.Docket}
                valueExpr={"Docket"}
                displayExpr={"Docket"}
                opened={isGridBoxOpened}
                onOptionChanged={onGridBoxOpened}
                contentRender={(value, element) => (
                  <DataGrid
                    dataSource={dataSource}
                    hoverStateEnabled={true}
                    height={"auto"}
                    onRowClick={(e) => {
                      setSelectedValue(e?.data);
                      setDocketvalidation("");
                      setIsGridBoxOpened(false);
                    }}
                  >
                    <Selection mode="single" />
                    <FilterRow visible={true} />
                    <Column dataField="Court" caption="Court" width={"auto"} />
                    <Column dataField="Docket" caption="Docket" width={"auto"} />
                    <Column dataField="Sentence Date" caption="Sentence Date" width={"auto"} />
                    <Column dataField="Supervision Status" caption="Supervision Status" width={"auto"} />
                  </DataGrid>
                )}
              />
              {docketvalidation && (
                <p className="error_validation" style={{ position: "absolute", top: "100px" }}>
                  {docketvalidation}
                </p>
              )}
            </div>
            {/* <div className="edit_content_flex">
              <p className="edit_container_label">Days Completed</p>
              <input
                id="daysCompleted"
                name="daysCompleted"
                type="number"
                placeholder="Enter Days Completed"
                className="edit_container_input"
                value={fields.daysCompleted}
                onChange={handleInputChange}
              />
            </div> */}
          </div>
          <div className="edit_container_first">
            <div className="edit_content_flex small-input">
              <p className="edit_container_label">
                Days Completed <span className="marks_mandatary">*</span>
              </p>
              <input
                id="daysCompleted"
                name="daysCompleted"
                type="number"
                placeholder="Enter Days Completed"
                className="edit_container_input"
                value={fields.daysCompleted}
                onChange={handleInputChange}
              />
            </div>
            <div className="edit_content_flex large-input">
              <p className="edit_container_label">
                Date Completed<span className="marks_mandatary">*</span>
              </p>
              <DateBox displayFormat={getDateBoxFormat()}
                useMaskBehavior={true}
                value={fields.date}
                onValueChange={(e) => {
                  setFields((prev) => ({
                    ...prev,
                    date: e,
                  }));
                  setDateValidation("");
                }}
              />
              {dateValidation && (
                <p className="error_validation" style={{ position: "absolute", top: "205px" }}>
                  {dateValidation}
                </p>
              )}
            </div>
            {/* <div className="edit_content_flex edit_content_space">
              <p className="edit_container_label">
                Jail Site <span className="marks_mandatary">*</span>
              </p>
              <DropDown
                setfields={setFields}
                fields={fields}
                fieldNmae={"workSite"}
                // dropDownData={JailtimelogDropdown?.map((vall) => {
                //   return {
                //     name: vall?.value,
                //     id: vall?.key,
                //   };
                // })}
                // dropDownData={jailPlannedData
                //   ?.filter((row) => !row?.Void)
                //   ?.map((row) => ({
                //     name: row?.["Jail Site"],
                //     id: row?.workSiteId,
                //   }))}
                dropDownData={jailPlannedData
                  ?.filter((row) => !row?.Void)
                  ?.reduce((unique, row) => {
                    if (!unique.some((u) => u.id === row.workSiteId)) {
                      unique.push({
                        name: row?.["Jail Site"],
                        id: row?.workSiteId,
                      });
                    }
                    return unique;
                  }, [])}
              />
              {workSitevalidation && (
                <p className="error_validation" style={{ position: "absolute", top: "205px" }}>
                  {workSitevalidation}
                </p>
              )}
            </div> */}
          </div>
          <div className="edit_container_first">
             <div className="edit_content_flex edit_content_space">
              <p className="edit_container_label">
                Jail Site <span className="marks_mandatary">*</span>
              </p>
              <DropDown
                setfields={setFields}
                fields={fields}
                fieldNmae={"workSite"}
                // dropDownData={JailtimelogDropdown?.map((vall) => {
                //   return {
                //     name: vall?.value,
                //     id: vall?.key,
                //   };
                // })}
                // dropDownData={jailPlannedData
                //   ?.filter((row) => !row?.Void)
                //   ?.map((row) => ({
                //     name: row?.["Jail Site"],
                //     id: row?.workSiteId,
                //   }))}
                dropDownData={jailPlannedData
                  ?.filter((row) => !row?.Void)
                  ?.reduce((unique, row) => {
                    if (!unique.some((u) => u.id === row.workSiteId)) {
                      unique.push({
                        name: row?.["Jail Site"],
                        id: row?.workSiteId,
                      });
                    }
                    return unique;
                  }, [])}
              />
              {workSitevalidation && (
                <p className="error_validation" style={{ position: "absolute", top: "205px" }}>
                  {workSitevalidation}
                </p>
              )}
            </div>
          </div>
          <div className="edit_container_first">
            <div className="edit_content_flex edit_content_space">
              <p className="edit_container_label">
                Reason <span className="marks_mandatary">*</span>
              </p>
              <DropDown
                setfields={setFields}
                fields={fields}
                fieldNmae={"reason"}
                // dropDownData={dropdownData?.jailReasons?.map((vall) => {
                //   return {
                //     name: vall?.value,
                //     id: vall?.key,
                //   };
                // })}
                // dropDownData={jailPlannedData
                //   ?.filter((row) => !row?.Void)
                //   ?.map((row) => ({
                //     name: row?.["Reason for JT"],
                //     id: row?.jailTimeReasonId,
                //   }))}
                // dropDownData={jailPlannedData
                //   ?.filter((row) => !row?.Void && row?.workSiteId === fields?.workSite?.id)
                //   ?.map((row) => ({
                //     name: row?.["Reason for JT"],
                //     id: row?.jailTimeReasonId,
                //   }))}
                dropDownData={jailPlannedData
                  ?.filter((row) => !row?.Void && row?.workSiteId === fields?.workSite?.id)
                  ?.reduce((unique, row) => {
                    if (!unique.some((u) => u.id === row.jailTimeReasonId)) {
                      unique.push({
                        name: row?.["Reason for JT"],
                        id: row?.jailTimeReasonId,
                      });
                    }
                    return unique;
                  }, [])}
                reset={setReasonvalidation}
              />
              {reasonvalidation && (
                <p className="error_validation" style={{ position: "absolute", top: "303px" }}>
                  {reasonvalidation}
                </p>
              )}
            </div>
          </div>
          <div className="edit_container_first space_removed">
            <p className="edit_container_label">Service Type</p>
            <input
              id="daysServed"
              name="daysServed"
              type="radio"
              value="daysServed"
              checked={serviceType === "daysServed"}
              onChange={handleServiceTypeChange}
            />
            <label htmlFor="daysServed" className="edit_container_label">
              Days Served
            </label>
            <input
              id="hoursWrittenOff"
              name="hoursWrittenOff"
              type="radio"
              value="hoursWrittenOff"
              checked={serviceType === "hoursWrittenOff"}
              onChange={handleServiceTypeChange}
            />
            <label htmlFor="hoursWrittenOff" className="edit_container_label">
              Hours Written Off
            </label>
          </div>
          {serviceType === "hoursWrittenOff" && (
            <div className="edit_container_second edit_content_flex">
              <textarea
                name="hoursWrittenOff"
                id="hoursWrittenOff"
                placeholder="Write Hours Written Off"
                value={fields.hoursWrittenOff}
                onChange={handleInputChange}
                className="dark-mode-textarea"
              ></textarea>
              {hoursWrittenOffValidation && (
                <p className="error_validation" style={{ position: "absolute", top: "513px" }}>
                  {hoursWrittenOffValidation}
                </p>
              )}
            </div>
          )}
          <div className="popup_buttons">
            <button className="btn primary_btn" onClick={handleSave}>
              Save
            </button>
            <button
              className="btn"
              onClick={() => {
                setAddJailServiceLogPopup(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </ScrollView>
    </div>
  );
};
